<div class="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
  <app-auth-header></app-auth-header>
  <p-toast></p-toast>

  <div class="flex-1 flex items-center justify-center bg-gradient-to-br from-jamaica-green-600 to-jamaica-green-900 p-6">
    <div class="w-full max-w-4xl">
      <div class="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-8">
        <!-- Logo & Header -->
        <div class="text-center mb-6">
          <img src="/logos/wsy-yardBull-Icon.png" alt="Wall St Yardie Logo" class="h-16 w-16 mx-auto mb-4" />
          <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">Terms of Service & Privacy Policy</h1>
          <p class="text-gray-600 dark:text-gray-400">Please review and accept to continue</p>
        </div>

        <!-- Scrollable Terms Content -->
        <div class="max-h-96 overflow-y-auto border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6 bg-gray-50 dark:bg-gray-900">
          <!-- Terms of Service Section -->
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4">Terms of Service</h2>
          <p class="text-sm text-gray-700 dark:text-gray-300 mb-4">
            Last updated: December 2, 2025
          </p>
          
          <div class="space-y-4 text-sm text-gray-700 dark:text-gray-300">
            <section>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">1. Introduction</h3>
              <p class="leading-relaxed">
                Welcome to Wall St Yardie Inc ("we," "our," or "us"). These Terms of Service ("Terms") govern your use of our website,
                mobile application, and services (collectively, the "Service") operated by Wall St Yardie Inc.
              </p>
              <p class="leading-relaxed mt-2">
                By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of these terms,
                then you may not access the Service.
              </p>
            </section>

            <section>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">2. Acceptance of Terms</h3>
              <p class="leading-relaxed">
                By accessing and using Wall St Yardie Inc, you accept and agree to be bound by the terms and provision of this agreement.
                Additionally, when using this website's particular services, you shall be subject to any posted guidelines or rules
                applicable to such services.
              </p>
            </section>

            <section>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">3. Use License</h3>
              <p class="leading-relaxed mb-2">
                Permission is granted to temporarily download one copy of the materials on Wall St Yardie Inc's website for personal,
                non-commercial transitory viewing only.
              </p>
            </section>

            <p class="text-xs text-gray-500 dark:text-gray-400 mt-4">
              For full Terms of Service, visit <a routerLink="/terms" target="_blank" class="text-jamaica-green-600 hover:underline">wallstyardie.com/terms</a>
            </p>
          </div>

          <!-- Privacy Policy Section -->
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white mb-4 mt-8">Privacy Policy</h2>
          <p class="text-sm text-gray-700 dark:text-gray-300 mb-4">
            Last updated: December 2, 2024
          </p>

          <div class="space-y-4 text-sm text-gray-700 dark:text-gray-300">
            <section>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">1. Information We Collect</h3>
              <p class="leading-relaxed">
                We collect information that you provide directly to us, including when you create an account, subscribe to our service,
                or communicate with us. This may include your name, email address, and payment information.
              </p>
            </section>

            <section>
              <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-2">2. How We Use Your Information</h3>
              <p class="leading-relaxed">
                We use the information we collect to provide, maintain, and improve our services, to process your transactions,
                and to communicate with you about your account and our services.
              </p>
            </section>

            <p class="text-xs text-gray-500 dark:text-gray-400 mt-4">
              For full Privacy Policy, visit <a routerLink="/privacy" target="_blank" class="text-jamaica-green-600 hover:underline">wallstyardie.com/privacy</a>
            </p>
          </div>
        </div>

        <!-- Acceptance Checkbox -->
        <div class="flex items-start space-x-3 mb-6">
          <input
            id="termsAccepted"
            type="checkbox"
            [(ngModel)]="termsAccepted"
            class="mt-1 h-5 w-5 text-jamaica-green-600 focus:ring-jamaica-green-500 border-gray-300 rounded"
          />
          <label for="termsAccepted" class="text-sm text-gray-700 dark:text-gray-300">
            I have read and agree to the
            <a routerLink="/terms" target="_blank" class="text-jamaica-green-600 hover:text-jamaica-green-700 underline font-medium">Terms of Service</a>
            and
            <a routerLink="/privacy" target="_blank" class="text-jamaica-green-600 hover:text-jamaica-green-700 underline font-medium">Privacy Policy</a>.
          </label>
        </div>

        <!-- Action Button -->
        <p-button
          label="Accept and Continue"
          icon="pi pi-check"
          styleClass="w-full"
          [loading]="loading()"
          [disabled]="!termsAccepted || loading()"
          (click)="onAccept()"
        ></p-button>
      </div>
    </div>
  </div>

  <app-auth-footer></app-auth-footer>
</div>
